module.exports = __webpack_public_path__ + "static/media/InfoIcon.ce4c444a.svg";